<template>
  <v-container>
      <v-row>
          <v-col>
              <v-row justify="center">
                  <v-card width="460" flat class="mt-10">
                      <v-form> 
                          <v-textarea
                            outlined
                            v-model="description"
                            label="Menu description"
                          ></v-textarea>
                          <v-text-field
                            label="price"
                            v-model="price"
                            outlined
                            dense
                          ></v-text-field>
                        <v-text-field
                            label="menu name"
                            v-model="menuName"
                            outlined
                            dense
                          ></v-text-field>
                          <v-row>
                              <v-col cols="12" md="4">
                                  <v-checkbox label="Break Fast" v-model="breakfast"></v-checkbox>
                              </v-col>              
                              <v-col cols="12" md="4">
                                  <v-checkbox label="Launch" v-model="launch"></v-checkbox>
                              </v-col>
                            
                              <v-col cols="12" md="4">
                                  <v-checkbox label="Dinner" v-model="dinner"></v-checkbox>
                              </v-col>
                          </v-row>

                            <v-file-input label="Attch profile Picture"
                                v-model="image"
                                name = "file"
                            ></v-file-input>         
                      </v-form>
                      <v-btn color="primary" width="460" @click="submit">submit</v-btn>
                  </v-card>

              </v-row>
          </v-col>
      </v-row>
  </v-container>
</template>

<script>
import {mapActions} from "vuex"
export default {
    name: "upload",
    data() {
        return {
            breakfast: false,
            launch: false,
            dinner: false,
            menuName: "",
            description: "",
            price: "",
            image: []
        }
    },
    methods: {
        ...mapActions(['newProductPost']),
        submit() {
            let item = new FormData();
            item.append('image', this.image);
            item.append('breakfast', this.breakfast);
            item.append('launch', this.launch);
            item.append('dinner', this.dinner);
            item.append('menuName', this.menuName);
            item.append('description', this.description);
            item.append('price', this.price);
            this.newProductPost(item);
        }
    }

}
</script>

<style>

</style>